import { memo } from 'react';
import { ChevronDownIcon, ChevronTopIcon } from '../icons';

const SortIndicator = ({
    asc,
}: {
    /**
     * The ascendant indicator
     */
    asc?: boolean;
}) => {
    return <span>{asc ? <ChevronTopIcon /> : <ChevronDownIcon />}</span>;
};

export default memo(SortIndicator);
